import React from "react";
import useTheme from "../../../../hooks/useTheme";
import { connect } from "react-redux";
import { closeModal } from "../../../../redux/Modals/ModalActions";
import { Icon, Modal } from "semantic-ui-react";
import { useResponsive } from "../../../UI/ResponsiveContext";
import { AppColumn, AppRow } from "../../../UI/Layouts";
import AppText from "../../../UI/Texts/AppTexts";
import { SizedBox } from "../../../UI/Sizes";
import { CloseCircleButton } from "../../../UI/CustomButtons";
import { t } from "i18next";


const ApplicationProcessDetails = ({ closeModal }) => {
    const theme = useTheme();
    const { isMobile } = useResponsive();


    const steps = [
        {
            id: 'interested',
            title: t('application.status.applied'),
            description: t('application.status.applied.description'),
            duration: t('application.status.applied.duration'),
            icon: 'paper plane',
        },
        {
            id: 'documented',
            title: t('application.status.documented'),
            description: t('application.status.documented.description'),
            duration: t('application.status.documented.duration'),
            icon: 'file alternate',
        },
        {
            id: 'qualified',
            title: t('application.status.qualified'),
            description: t('application.status.qualified.description'),
            duration: t('application.status.qualified.duration'),
            icon: 'check circle',
        },
        {
            id: 'presented',
            title: t('application.status.presented'),
            description: t('application.status.presented.description'),
            duration: t('application.status.presented.duration'),
            icon: 'user check',
        },
        {
            id: 'hired',
            title: t('application.status.hired'),
            description: t('application.status.hired.description'),
            duration: t('application.status.hired.duration'),
            icon: 'user md',
        },

    ]

    return (
        <Modal
            basic
            key="ApplicationProcessDetails"
            centered={true}
            open={true}
            closeOnEscape={true}
            closeOnDimmerClick={true}
            onClose={() => {
                closeModal();
            }}
            style={{
                margin: "0",
                padding: "0",
                top: "0",
                borderRadius: isMobile ? "0px" : theme.radius.default,
                height: isMobile && "100%",
                width: isMobile ? "100%" : "60%",
                marginTop: isMobile ? "0px" : theme.spacing.contentPadding,
                marginBottom: isMobile ? "0px" : theme.spacing.contentPaddingBig,
                backgroundColor: theme.colors.white,
                transform: "none",
            }}>

            <AppColumn
                style={{
                    height: "100%",
                    maxHeight: !isMobile && '90vh',

                }}
                crossAxisAlignment={"stretch"}>

                <div style={{
                    flex: "1", overflowY: "auto",
                    padding: theme.spacing.contentElementPadding,

                }}>
                    <AppRow mainAxisAlignment={'space-between'} crossAxisAlignment={'center'} >
                        <AppText.SubHeading fontWeight={600} color={theme.primaryColor}>{t('application.status.explain.title')}</AppText.SubHeading>
                        <CloseCircleButton onClick={closeModal} />

                    </AppRow>
                    <SizedBox height={theme.spacing.elementPaddingSmall} />
                    <AppText.Caption fontWeight={400} margins={{ marginBottom: '0px' }} color={theme.colors.dark}>
                        {t('application.status.explain.description')}
                    </AppText.Caption>

                    <SizedBox height={theme.spacing.elementPadding} />
                    <AppText.Caption >{t('application.status.explain.description_2', { appName: theme.appName })}</AppText.Caption>
                    <SizedBox height={theme.spacing.contentElementPadding} />

                    <AppText.Caption fontWeight={600}>{`${t('application.status.explain.steps.title')}:`}</AppText.Caption>
                    <SizedBox height={theme.spacing.elementPadding} />

                    {steps.map((step, index) => {

                        return (<div key={step.key} style={{ display: 'flex', alignItems: 'start', position: 'relative', marginBottom: theme.spacing.contentElementPadding }}>
                            {index !== (steps.length - 1) && (
                                <div style={{
                                    position: 'absolute',
                                    left: '20px',
                                    top: '25px',
                                    width: '2px',
                                    height: '100px',
                                    backgroundColor: theme.colors.grey
                                }} />
                            )}
                            <div style={{
                                marginRight: '15px',
                                zIndex: 1,
                                marginTop: theme.spacing.elementPaddingSmall,
                                backgroundColor: theme.colors.white,
                                borderRadius: theme.radius.default,
                                padding: '0.5rem',

                            }}>
                                <Icon name={step.icon} size="large" style={{
                                    color: theme.primaryColor,
                                    fontSize: '1.8rem',
                                }} />
                            </div>
                            <AppColumn crossAxisAlignment={'start'}>
                                <AppText.Caption fontWeight={600}>{`${step.title}`}</AppText.Caption>
                                <SizedBox height={'0.4rem'} />
                                <AppText.Footnote >{step.description}</AppText.Footnote>
                                <SizedBox height={'0.4rem'} />
                                <AppText.FootnoteSmall color={theme.colors.grey} fontWeight={400}>{`${t('typically')}: ${step.duration}`}</AppText.FootnoteSmall>

                            </AppColumn>

                        </div>
                        );
                    })}

                </div>
            </AppColumn>
        </Modal>
    );
}


export default connect(null, {
    closeModal,
})(ApplicationProcessDetails);

export const MODAL_APPLICATION_PROCESS_DETAIL = "ApplicationProcessDetails";
